import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import {
    SectionHeader,
    TrueFalseRadio,
} from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { FsaTypArrays, FsaTypeMap, FirmTypeMap, FcaTradingStatusMap } from "../../../Resource/Content";
import { Table } from "../../../../../../Shared/Table/Table";
import { EmailAddress } from "../../../../../../../Wrap/Models/Domains/Personal/EmailAddress";
import { NetworkType } from "../../../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { FirmType } from "../../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { ValidatorContents } from "../../../../../../Dashboard/Common/ValidatorHelper";
import { AllowFourSpecial, Email, Numeric} from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { DistributionArray, DistributionMap } from "../../../../../Network/Resource/Content";
import { CompanyWizardAction } from "../../../Actions/CompanyWizardAction";
import { NetworkHistoryPaginatedModel } from "../../../../../../../Wrap/Models/Models/Network/NetworkHistoryPaginatedModel";
import { NetworkHistoryModel } from "../../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { Typography } from "../../../../../../Shared/Typography/Typography";

interface IContactDetailProps {
    isReview?: boolean;
    data: FirmInstruction;
    onChange: (changes) => void;
    onRef: (ref) => void;
    onNetworkSelectionChange: (network: NetworkHistoryModel) => void;
    currentNetwork: NetworkHistoryModel;
    canEditNetwork: boolean;
}

interface IContactDetailState {
    Network: NetworkHistoryPaginatedModel;
    currentPage: number;
    pendingNetworkSelection: boolean;
    NetworkName: string;
    FsaAuthorisationNumber: string;
    PostCode: string;
    confirmEmail: EmailAddress;
}

export class ContactDetail extends FormComponent<IContactDetailProps, IContactDetailState> {
    constructor(props: IContactDetailProps) {
        super(props);
        this.state = {
            Network: null,
            currentPage: 0,
            NetworkName: null,
            FsaAuthorisationNumber: null,
            PostCode: null,
            confirmEmail: props.data.EmailAddress,
            pendingNetworkSelection: false,
        };
    }

    componentDidMount() {
        this.props.onRef(this);
        this.props.onChange({ WhiteLabel: false });
    }

    private getNetworkList(pageIndex, pageSize) {
        if(pageIndex < 1){
            pageIndex = 1
        }
        const promise = CompanyWizardAction.getNetwork({
            NetworkName: this.state.NetworkName,
            TradingReference: this.state.FsaAuthorisationNumber,
            PostCode: this.state.PostCode,
            Max: pageSize * pageIndex,
            Min: pageSize * (pageIndex - 1) + 1,
            NetworkType: NetworkType.Network,
        });

        promise.onSuccess((data) => {
            this.setState({ pendingNetworkSelection: true, Network: data });
        });
    }

    private renderAdviserType() {
        const { data, isReview } = this.props;
        const { currentNetwork } = this.props;
        const address = currentNetwork?.Address;
        return (
            <>
                {this.props.canEditNetwork && (
                    <>
                        <TextBoxEditor
                            disabled={isReview}
                            label={"Network name:" + (data.FirmType == FirmType.AppointedRepresentative ? "*" : "")}
                            value={this.state.NetworkName}
                            onChange={(v) => this.setState({ NetworkName: v })}
                        />
                        <TextBoxEditor
                            disabled={isReview}
                            label="Network FCA/Trading reference:"
                            maxLength={8}
                            regex={{ errorMessage: "Must be numbers", value: Numeric }}
                            value={this.state.FsaAuthorisationNumber}
                            onChange={(v) => this.setState({ FsaAuthorisationNumber: v })}
                        />
                        <TextBoxEditor
                            disabled={isReview}
                            label="Network postcode:"
                            value={this.state.PostCode}
                            onChange={(v) => this.setState({ PostCode: v })}
                        />
                        <button
                            className="btn secondary"
                            disabled={isReview}
                            onClick={() => {
                                this.getNetworkList(1, 10);
                            }}
                        >
                            Search
                        </button>
                        <br />
                        <br />
                    </>
                )}

                {currentNetwork && (
                    <>
                        {SectionHeader("Network detail")}
                        <Typography
                            type="common"
                            config={[
                                { title: "Network name", data: this.props.currentNetwork.NetworkName },
                                {
                                    title: "Type of network",
                                    data:
                                        this.props.currentNetwork.NetworkType == NetworkType.ServiceProvider
                                            ? "Service Provider"
                                            : "Network",
                                },
                                { title: "FCA/Trading reference", data: this.props.currentNetwork.FcaTradingReference },
                                {
                                    title: "FCA/Trading status",
                                    data: FcaTradingStatusMap[this.props.currentNetwork.FcaTradingStatus],
                                },
                                { title: "Postcode", data: this.props.currentNetwork.Address?.Postcode },
                                {
                                    title: "Network address",
                                    data: address
                                        ? this.joinNotNull(
                                              [address.Line1, address.Line2, address.Line3, address.Line4],
                                              " "
                                          )
                                        : null,
                                },
                                { title: "", data: address?.Line1 },
                                { title: "", data: address?.Line2 },
                                { title: "", data: address?.Line3 },
                                { title: "", data: address?.Line4 },
                            ]}
                        />
                    </>
                )}

                {currentNetwork && this.props.canEditNetwork && (
                    <button className="btn secondary mb-30" onClick={() => this.onNetworkSelectionChange(null)}>
                        {"Delete"}
                    </button>
                )}

                {this.state.pendingNetworkSelection && (
                    <Table
                        col={[
                            {
                                title: "Network",
                                key: "Network",
                            },
                            {
                                title: "Network name",
                                key: "NetworkName",
                            },
                            { title: "FCA/Trading reference", key: "FcaTradingReference" },
                            { title: "Postcode", key: "PostCode" },
                            {
                                title: "Select",
                                render: () => {
                                    return <button className="btn secondary">{"Select"}</button>;
                                },
                                onClick: (data, row) => {
                                    this.onNetworkSelectionChange(row);
                                    this.setState({ pendingNetworkSelection: false });
                                },
                            },
                        ]}
                        showEmptyMsg={true}
                        data={this.state.Network.networks}
                        needPagination={{
                            totalNumOfResult: this.state.Network.TotalRows,
                            currentPage: this.state.currentPage,
                            onPaginationChange: (pageIndex, pageSize) => this.getNetworkList(pageIndex, pageSize),
                        }}
                    />
                )}
                <SelectEditor
                    options={FsaTypArrays}
                    getText={(v) => {
                        return FsaTypeMap[v];
                    }}
                    disabled={isReview}
                    placeholder="Please select"
                    required="Please select regulated firm type"
                    label="Regulated firm type:"
                    selected={data.FsaType}
                    onChange={(v) => this.props.onChange({ FsaType: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Email address:*"
                    required="Please enter email address"
                    value={data.EmailAddress.Value}
                    regex={{ errorMessage: ValidatorContents.InvalidEmail, value: Email }}
                    onChange={(v) => this.props.onChange({ EmailAddress: { Value: v } })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Confirm email address:*"
                    required="Please enter confirm email address"
                    value={this.state.confirmEmail.Value}
                    notAllowPaste={true}
                    onChange={(v) => this.setState({ confirmEmail: { Value: v } })}
                    validationRules={[
                        {
                            errorMessage: "Must be same as email address",
                            validator: (v) => {
                                if (v) {
                                    return v == data.EmailAddress.Value ? true : false;
                                }
                                return true;
                            },
                        },
                    ]}
                />
                <SelectEditor
                    disabled={isReview}
                    options={DistributionArray}
                    getText={(v) => {
                        return DistributionMap[v];
                    }}
                    required="Please select distribution channel"
                    placeholder="Please select"
                    label="Distribution channel:"
                    selected={data.DistributionChannel == 0 ? null : data.DistributionChannel}
                    onChange={(v) => this.props.onChange({ DistributionChannel: v ? v : 0 })}
                />
                {TrueFalseRadio(
                    "White label: ",
                    "WhiteLabel",
                    data,
                    (key, v) => {
                        this.props.onChange({ [key]: v });
                    },
                    true,
                    { disabled: true }
                )}
            </>
        );
    }

    private renderThirdParty() {
        const { data, isReview } = this.props;
        return (
            <>
                <TextBoxEditor
                    disabled={isReview}
                    label="Firm short name"
                    required="Please enter firm short name"
                    maxLength={8}
                    value={data.ShortName}
                    onChange={(v) => this.props.onChange({ ShortName: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Firm prefix name"
                    required="Please enter firm prefix name"
                    maxLength={20}
                    value={data.Prefix}
                    onChange={(v) => this.props.onChange({ Prefix: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Email address:"
                    value={data.EmailAddress.Value}
                    regex={{ errorMessage: ValidatorContents.InvalidEmail, value: Email }}
                    onChange={(v) => this.props.onChange({ EmailAddress: { Value: v } })}
                />
            </>
        );
    }

    render() {
        const { data, isReview } = this.props;
        const createType =
            data.FirmType == FirmType.AppointedRepresentative || data.FirmType == FirmType.DirectlyAuthorised
                ? "adviser"
                : "thirdParty";
        return (
            <>
                {SectionHeader("Contact details")}
                <TextBoxEditor
                    disabled={isReview}
                    label="Firm name: *"
                    required={"Please enter firm name"}
                    value={data.FirmName}
                    maxLength={50}
                    regex={{ value: AllowFourSpecial, errorMessage: "There are only 4 special characters allowed." }}
                    onChange={(v) => this.props.onChange({ FirmName: v })}
                />
                <p>Firm type:</p>
                <p>
                    {createType == "thirdParty"
                        ? "Third party firm - " + FirmTypeMap[data.FirmType]
                        : FirmTypeMap[data.FirmType]}
                </p>
                <p>Firm ID</p>
                <p>{data.CompanyCode}</p>
                {createType == "adviser" && this.renderAdviserType()}
                {createType == "thirdParty" && this.renderThirdParty()}
            </>
        );
    }

    private joinNotNull(str: string[], seperator: string): string {
        str = str.filter((x) => x != null);
        return str.join(seperator);
    }

    private onNetworkSelectionChange(network: NetworkHistoryModel) {
        this.setState({ pendingNetworkSelection: false });
        this.props.onNetworkSelectionChange(network);
        this.props.onChange({ Network: network?.Network });
    }
}
